module.exports = __webpack_public_path__ + "static/media/003 I GUERRA M_Piazza Cesare Battisti.4b3fe5b8.svg";